module.exports = __webpack_public_path__ + "3f037101504d51568440b73cd5bd7808.svg";